import { Box, Chip, CircularProgress, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { getResource } from "../../data/request";
import { getAddressDispay, getDateDisplay, getValueDisplay } from "../../data/utilities";
import { PSC } from "../../types/PSC";
import { STATUS_GREY, TEXT_SECONDARY } from "../colors";

export const PSCPage = (props: { link: string }) => {
  const { link } = props;
  const [persons, setPersons] = useState<PSC[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const doc = await getResource(link);
      setPersons(doc?.items ?? []);
      setLoading(false);
    };

    fetchData();
  }, [link]);

  if (loading) {
    return (
      <Box
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: 200,
        }}
      >
        <CircularProgress color="primary" />
      </Box>
    );
  }

  if (persons.length === 0) {
    return (
      <Box style={{ padding: 20 }}>
        <Typography variant="body2" style={{ color: TEXT_SECONDARY }}>
          No persons with significant control recorded for this company.
        </Typography>
      </Box>
    );
  }

  return (
    <Box style={{ padding: 20 }}>
      {persons.map((person, index) => {
        const isIndividual = person.kind?.startsWith("individual");
        return (
          <Box
            key={person.links?.self ?? index}
            style={{ padding: 16, marginBottom: 12, borderBottom: "1px solid #E2E2E7" }}
          >
            <Box style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 8 }}>
              <Typography variant="subtitle1">{person.name}</Typography>
              {person.ceased && (
                <Chip
                  label="Ceased"
                  size="small"
                  style={{ backgroundColor: STATUS_GREY, color: "white" }}
                />
              )}
            </Box>

            {isIndividual && (
              <Typography variant="body2" style={{ color: TEXT_SECONDARY }}>
                {getValueDisplay(person.nationality)} | Born{" "}
                {getDateDisplay(person.date_of_birth)}
              </Typography>
            )}

            {person.address && (
              <Typography variant="body2" style={{ color: TEXT_SECONDARY, marginTop: 4 }}>
                {getAddressDispay(person.address)}
              </Typography>
            )}

            {Array.isArray(person.natures_of_control) &&
              person.natures_of_control.length > 0 && (
                <Box style={{ marginTop: 8, display: "flex", flexWrap: "wrap", gap: 6 }}>
                  {person.natures_of_control.map((nature) => (
                    <Chip key={nature} label={getValueDisplay(nature)} variant="outlined" size="small" />
                  ))}
                </Box>
              )}
          </Box>
        );
      })}
    </Box>
  );
};
